import { useMutation } from "react-query";
import { PAYMENT_METHOD_ETH, PAYMENT_METHOD_STRIPE } from "../../constants";
import httpClient from "../http";

export type Product = {
  _id: string;
  count: number;
  sku: {
    option: string;
  };
};

export type Address = {
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  pincode: string;
  email: string;
  phone: string;
  country: string;
  region: string;
};

export type TransactionDto = {
  products: Product[];
  address: Address;
  paymentMethod: string;
  userId?: string;
  token?: string;
  coupon?: string;
};

export type Status = "Initiated" | "Paid" | "Delivered";

export type BoughtProduct = {
  productId: string;
  image: string;
  name: string;
  description: string;
  price: number;
  count: number;
  option: string;
  specification: string;
};

export type Transaction = {
  paymentId: string;
  userId: string;
  txHash: string;
  shippingFee: number;
  tax: number;
  price: number;
  priceToken: number;
  token: string;
  status: Status;
  products: BoughtProduct[];
  address: Address;
};

const getHeader = () => {
  const config = {
    headers: { "Content-type": "application/json" },
  };
  return config;
};

// eslint-disable-next-line import/prefer-default-export
export function useTransactionStore() {
  return useMutation(({ paymentMethod, ...data }: TransactionDto) => {
    let url = "";
    if (paymentMethod === PAYMENT_METHOD_STRIPE) {
      url = "transaction/stripe/payment";
    } else if (paymentMethod === PAYMENT_METHOD_ETH) {
      url = "transaction/paymentId";
    }

    return httpClient.post(url, data, getHeader());
  });
}
